<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import * as echarts from "echarts";

const chartContainer = ref(null);
let chartInstance = null;

const pieData = [
  { value: 146.94, name: "已建成高标准农田146.94万亩" },
  { value: 12, name: "正在实施高标准农田项目12万亩" },
];
const colors = ["#088BFF", "#61B5FF"];
const option = {
  legend: {
    show: true,
    orient: "vertical",
    left: "right", // 可以设置为'right'、'top'、'bottom'，取决于您希望图例出现在哪里
    top: "top", // 设置图例在容器顶部
    align: "left", // 设置图例内边距的对齐方式，'right' 表示图标靠右对齐，即文字在图标前面
    data: pieData.map((item) => item.name),
    padding: [60, 40, 20, 15],
    itemGap: 40,
    itemWidth: 30, // 设置图例标记的图形宽度，可适当增大使图标更大
    itemHeight: 30,
    textStyle: {
      color: "#fff", // 您可以自定义图例文字颜色
      fontSize: 30,
    },
  },
  series: [
    {
      label: {
        normal: {
          show: false,
        },
      },
      name: "Access From",
      type: "pie",
      radius: "70%",
      center: ["18%", "50%"],
      color: colors, // 添加颜色数组
      data: pieData,
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)",
        },
      },
    },
  ],
};

onMounted(() => {
  if (!chartContainer.value) return;

  chartInstance = echarts.init(chartContainer.value);

  chartInstance.setOption(option);

  // 响应窗口大小变化
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });
});

onBeforeUnmount(() => {
  // 清理资源
  if (chartInstance) {
    chartInstance.dispose();
    chartInstance = null;
  }
});
</script>
